// @flow
import React from "react";
import { StyledInput } from "./styles";

const TextBox = (props: Props) => <StyledInput {...props} numberOfLines={5} />;

export default TextBox;
